import React, { useState, useRef, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {Form, Card, Row, Col} from "react-bootstrap"
import { Link, useLocation, Redirect } from 'react-router-dom';

import { getUser } from "../actions/user-action";
import { changePassword } from "../actions/auth-action";
import { removeAuth } from "../common/Helpers";

import tokenHelper from "../helpers/tokenHelper";
import {AiOutlineEye, AiOutlineEyeInvisible} from 'react-icons/ai'
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

import nnImg from '../images/nn.png'
import AuthVerify from "../components/AuthVerify";
import { forEach } from "country-flags-svg/dist/data/countries";
import { MessageBar, MessageBarType } from "@fluentui/react";

export default function ChangePassword() {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const checkBtn = useRef();
  const location = useLocation();

  const { user: currentAuth } = useSelector((state) => state.auth);
  const username  = location.state.userName;

  const [userId, setUserId] = useState(null);
  const [email, setEmail] = useState("");
  
  const [successful, setSuccessful] = useState(false);
  
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const txtRefPassword = useRef()
  const txtRefPasswordConfirm = useRef();
  
  const [password, setPassword] = useState("");
  const [newpassword, setNewpassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [isInvalidNewPassword, setIsInvalidNewPassword] = useState(false);
  const [isInvalidPassword, setIsInvalidPassword] = useState(false);
  const [isInvalidPasswordConfirmation, setIsInvalidPasswordConfirmation] = useState(false);

  const [newPasswordMessageError, setNewPasswordMessageError] = useState("");
  const [passwordMessageError, setPasswordMessageError] = useState("");
  const [passwordConfirmationMessageError, setPasswordConfirmationMessageError] = useState("");
  const [showPasswordMessageBar, setShowPasswordMessageBar] = useState(true);

  const { _message } = useSelector(state => state.message);
  const [message, setMessage] = useState(_message);

  useEffect(()=> {
    if (userId === null) {
      dispatch(getUser(username)).then((response) => {
        let tokenUserName = tokenHelper.GetUserNameTokenData();  
        setContent(response.data, tokenUserName === username);
      }, (error) => {
        const _content =
          (error.response?.data?.message) ??
          (error.message ?? error.toString());

        setContent(_content, null);
      }).catch(() => {
        //Unimplemented.
      });
    }
  }, [userId, dispatch, username]);

  const setContent = (_content, _isCurrentUser) => {
    setUserId(_content.data.id);
    setEmail(_content.data.email);
  };

  const isValidPassword = (password, newpassword, passwordConfirmation) => {
    let passwordShemaValid = true;
    let passwordConfirmationShemaValid = true;
    
    if (password === "") {
      setPasswordMessageError(t('data-lang-msg-required-field'));
      setIsInvalidPassword(true);
    }

    if (newpassword === "") {
        passwordShemaValid = false;
        setNewPasswordMessageError(t('data-lang-msg-invalid-password'));
        setIsInvalidNewPassword(true);
    }

    if (passwordConfirmation === "") {
      passwordConfirmationShemaValid = false;
      setPasswordConfirmationMessageError(t('data-lang-msg-invalid-password'));
      setIsInvalidPasswordConfirmation(true);
    }

    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{10,}$)/
    if (regex.test(newpassword) === false) {
      passwordShemaValid = false;
      setNewPasswordMessageError(t('data-lang-msg-invalid-password'));
      setIsInvalidNewPassword(true);
    }

    if (passwordConfirmationShemaValid && passwordShemaValid) {
      if (newpassword !== passwordConfirmation) {
        setNewPasswordMessageError('');
        setPasswordConfirmationMessageError(t('data-lang-msg-notsame-passwordandconfirmation'));
        setIsInvalidNewPassword(false);
        setIsInvalidPasswordConfirmation(true);
        return (false)
      }
      else {
        return (true)
      }
    }
    else {
      return (false)
    }
  }

  const onChangeNewPassword = (e) => {
    const newpassword = e.target.value;
    setIsInvalidNewPassword(newpassword === "");
    setNewpassword(newpassword);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setIsInvalidPassword(password === "");
    setPassword(password);
  };
  
  const onChangePasswordConfirmation = (e) => {
    const passwordConfirmation = e.target.value;
    setIsInvalidPasswordConfirmation(passwordConfirmation === "");
    setPasswordConfirmation(passwordConfirmation);
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    
    setSuccessful(false);

    setMessage("");

    let _isValidPassword = isValidPassword(password, newpassword, passwordConfirmation);
    
    if (_isValidPassword) {
      dispatch(changePassword(userId, password, newpassword))
      .then((response) => {
        if (response.data.succeeded) {
          setSuccessful(true);
          setMessage(t('data-lang-msg-passwordretrieve-changed-success'));
          removeAuth().then(() => { window.location.href = "/login"; });
        }
        else {
          if (response.data.data.length > 0) {
            setSuccessful(false);
            setMessage(t(response.data.data[0]))
          }
          else {
            setMessage(t(response.data.data))
          }
        }
      })
      .catch(() => {
        setSuccessful(false);
        setMessage(t('data-lang-msg-passwordretrieve-changed-fail'));
      });
    } else {
      setSuccessful(false);
      setMessage(t('data-lang-msg-passwordretrieve-changed-fail'));
    }
  };

  const handleClosePasswordMessageBar = () => {
    setShowPasswordMessageBar(false);
  }

  const handleShowHidePassword = (e) => {
    if (e === "newpass") {
      setShowNewPassword(!showNewPassword);
    }
    if (e === "pass") {
      setShowPassword(!showPassword);
    }
    if (e === "passConfirm") {
      setShowPasswordConfirm(!showPasswordConfirm);
    }
  }

  return (
    <>
      <AuthVerify currentToken={currentAuth} />
      { (userId !== null) &&
        <Form>
          {!successful && (
            <>
            <Row>
              {showPasswordMessageBar &&
                <Col sm={12} md={12} lg={12} xl={12}>
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    styles={{root:{marginTop: "-96px !important"}}}
                    messageBarType={MessageBarType.warning}
                    onDismiss={()=> handleClosePasswordMessageBar()}>
                    <div>
                      <b>{t('data-lang-msg-warning')}:</b><br/>
                      <ul>
                        <li>
                          {t('data-lang-msg-password-policy-1')}
                        </li>
                        <li>
                          {t('data-lang-msg-password-policy-2')}
                        </li>
                        <li>
                          {t('data-lang-msg-password-policy-3')}
                        </li>
                        <li>
                          {t('data-lang-msg-password-policy-4')}
                        </li> 
                        <li>
                          {t('data-lang-msg-password-policy-5')}
                        </li> 
                      </ul>                
                    </div>
                  </MessageBar>
                </Col>
              }
              <Col sm={12} md={12} lg={12} xl={12}>
                <Card className="rounded-3">
                  <Card.Header>
                    <Card.Title>
                      <h4 style={{float:"left"}}><b>{t('data-lang-pagename-changepassword')}</b></h4>
                    </Card.Title>
                  </Card.Header>
                  <div className="mx-auto d-block d-sm-block d-md-none d-lg-none pt-4">  
                    <img alt="nn1" className="rounded-circle" width={125} src={nnImg}></img>
                  </div>
                  <div className="card-horizontal">
                    <div className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
                      <img alt="nn2" className="rounded-circle" width={125} src={nnImg}></img>
                    </div>
                    <Card.Body className="col-xs-12">
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={4} xl={4} className="pt-3">
                          <Form.Label>{t('data-lang-lbl-username')}</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control"
                            name="username"
                            value={username || ''}
                            disabled ="disabled "
                          />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={4} xl={4} className="pt-3">
                          <Form.Label>{t('data-lang-lbl-email')}</Form.Label>
                          <Form.Control
                              type="text"
                              className="form-control"
                              name="email"
                              value={email || ''}
                              placeholder="example@company.com"
                              disabled ="disabled "
                              autoComplete="off"
                            />
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={6} md={6} lg={4} xl={4} className="pt-3">
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="password">{t('data-lang-lbl-oldpassword')}</Form.Label>
                            <div className="input-group mb-3">
                              <Form.Control
                                id="txtPassword"
                                ref={txtRefPassword}
                                name="password"
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={password}
                                onChange={onChangePassword}
                                isInvalid={isInvalidPassword !== null ? isInvalidPassword : false}
                                placeholder="" required={true} /> 
                              <span className="input-group-text" onKeyDown={() => handleShowHidePassword("pass")}  onClick={() => handleShowHidePassword("pass")} role="button" tabIndex={-1}>
                                {!showPassword && <AiOutlineEyeInvisible />}
                                {showPassword && <AiOutlineEye />}
                              </span>
                              {
                                isInvalidPassword === true &&
                                <div className="invalid-feedback">
                                  {passwordMessageError}
                                </div>
                              } 
                            </div>
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={4} xl={4} className="pt-3">
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="newpassword">{t('data-lang-lbl-newpassword')}</Form.Label>
                            <div className="input-group mb-3">
                              <Form.Control
                                id="txtNewPassword"
                                ref={txtRefPassword}
                                name="newpassword"
                                type={showNewPassword ? "text" : "password"}
                                className="form-control"
                                value={newpassword}
                                onChange={onChangeNewPassword}
                                isInvalid={isInvalidNewPassword !== null ? isInvalidNewPassword : false}
                                placeholder="" required={true} /> 
                              <span className="input-group-text" onKeyDown={() => handleShowHidePassword("newpass")} onClick={() => handleShowHidePassword("newpass")} role="button" tabIndex={0}>
                                {!showNewPassword && <AiOutlineEyeInvisible />}
                                {showNewPassword && <AiOutlineEye />}
                              </span>
                              {
                                isInvalidNewPassword === true &&
                                <div className="invalid-feedback">
                                  {newPasswordMessageError}
                                </div>
                              } 
                            </div>
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={4} xl={4} className="pt-3">
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="passwordconfirmation">{t('data-lang-lbl-passwordconfirmation')}</Form.Label>
                            <div className="input-group mb-3">
                              <Form.Control
                                id="txtPasswordConfirmation"
                                ref={txtRefPasswordConfirm}
                                name="passwordConfirmation"
                                type={showPasswordConfirm ? "text" : "password"}
                                className="form-control"
                                value={passwordConfirmation}
                                onChange={onChangePasswordConfirmation}
                                isInvalid={isInvalidPasswordConfirmation !== null ? isInvalidPasswordConfirmation : false}
                                placeholder="" required={true} />
                                <span className="input-group-text" onKeyDown={() => handleShowHidePassword("passConfirm")} onClick={() => handleShowHidePassword("passConfirm")} role="button" tabIndex={-1}>
                                  {!showPasswordConfirm && <AiOutlineEyeInvisible />}
                                  {showPasswordConfirm && <AiOutlineEye />}
                                </span>
                                {
                                  isInvalidPasswordConfirmation === true &&
                                  <div className="invalid-feedback">
                                    {passwordConfirmationMessageError}
                                  </div>
                                }
                              </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  </div>
                </Card>
              </Col>
            </Row>
            {(userId !== null) &&
              <Row className="d-md-flex justify-content-md-end">
                <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
                  <button onClick={handleResetPassword} data-component-id="btnEdit" className="btn btn-primary col-12 mt-2">{t('data-lang-btn-change')}</button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
                  <Link to="/profile">
                    <button data-component-id="btnGoHome" className="btn btn-primary col-12 mt-2">{t('data-lang-btn-gohome')}</button>
                  </Link>
                </Col>
              </Row>
            }
            </>
          )}
          {successful && (
            <div className="form-group">
              <div className={ successful ? "alert alert-success" : "alert alert-danger" } role="alert">
                {message}
              </div>
            </div>
          )}
          <Form.Check style={{ display: "none" }} ref={checkBtn} />
        </Form>
      }
      { (userId === null) &&
        <Shimmer
            customElementsGroup={
              <div>
                <div style={{ display: 'flex' }}>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 125 },
                            { type: ShimmerElementType.gap, width: 16, height: 125 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        width="100%"
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                        ]}
                    />
                </div>
              </div>
            }
            styles={{
                root: {
                    width:"100%",
                    height:"150px",
                    backgroundColor: "white"}
                }
            }
            className="pt-4"
            isDataLoaded={userId !== null}>
        </Shimmer>
      }
    </>
  );
}
